<template>
  <hic-dialog append-to-body :close-on-click-modal="false" @open="open" :visible="visible" width="55rem" title="角色编辑" @close="cancel">
    <el-form :inline="true" :model="entity" :rules="comRules" ref="editor" style="padding-right: 4rem">
      <el-form-item label="编码" prop="code">
        <el-input type="text" placeholder="请输入角色编码" v-model.trim="entity.code" :disabled="!!entity.id" size="small" />
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input type="text" placeholder="请输入角色名称" v-model.trim="entity.name" size="small"></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="seqNo">
        <el-input type="number" placeholder="请输入角色排序" v-model.number="entity.seqNo" size="small" style="width: 5rem" />
      </el-form-item>
    </el-form>

    <split-pane @resize="resize" :min-percent="10" :default-percent="50" split="vertical" v-loading="loading || saving" style="height: 30rem">
      <template slot="paneL">
        <div class="paneL">
          <h3 class="center warning">子系统</h3>
          <el-row type="flex" style="flex-wrap: wrap">
            <el-button v-for="s in sysList" :key="s.code" class="left-pad bottom-pad" @click="confirm(s)" :type="s == sys ? 'primary' : 'warning'" size="mini" round>
              <span>{{ s.code | dictText("Sys") }}</span>
            </el-button>
          </el-row>
        </div>
      </template>
      <template slot="paneR">
        <div class="f-h" style="overflow: auto">
          <h3 class="center primary">
            <span v-if="sys.sysCode" style="color: #409eff; font-weight: bold">{{ sys.sysCode | dictText("Sys") }}</span>
            <span v-else> 权限配置 </span>
          </h3>
          <el-tree @check="check" ref="ptree" :data="sys.treeData" :props="{ children: 'children', label: 'name' }" node-key="code" show-checkbox check-on-click-node default-expand-all :expand-on-click-node="false" empty-text="没有可配置的权限"></el-tree>
        </div>
      </template>
    </split-pane>

    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button type="primary" @click="save" :disabled="saving" :loading="saving">确 定</el-button>
    </div>
  </hic-dialog>
</template>
<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  import splitPane from "vue-splitpane";
  export default {
    components: {
      splitPane,
      // treeTransfer,
      // 'i-el-transfer': ()=>import('../treeTransfer/main')
    },
    props: {
      visible: Boolean,
      roleId: Number,
    },
    data() {
      var validateCode = (rule, value, callback) => {
        if (!/^[0-9a-zA-Z_-]*$/.test(value)) {
          return callback(new Error("编码只能包含：【大小写字母】【数字】【_】【-】"));
        }
        return callback();
      };
      return {
        sys: {
          treeData: [],
          sysCode: undefined,
        },
        mode: "transfer",
        treeData: [],
        value: "",
        entity: {},
        comRules: {
          name: [
            { required: true, message: "请输入名称", trigger: "blur" },
            { max: 128, message: "名称长度在 128 个字符以内", trigger: "blur" },
          ],
          code: [
            { required: true, message: "请输入编码", trigger: "blur" },
            { max: 64, message: "编码长度在 64 个字符以内", trigger: "blur" },
            { validator: validateCode, trigger: "blur" },
          ],
          seqNo: [
            {
              required: false,
              type: "number",
              message: "排序只允许是数字",
              trigger: "blur",
            },
          ],
        },
        loading: false,
        saving: false,
        actTab: null,
        permissionJsonString: null,
        sysList: [],
      };
    },
    computed: {
      ...mapGetters(["setting", "user"]),
    },
    watch: {},
    created() {
      let _this = this;
      api.TenantApply.query({
        pageIndexOnView: 1,
        pageSize: 999,
      })
        .then((res) => {
          res.items.forEach((item) => {
            item.code = item.sysCode;
            item.treeData = _this.$utils.PermissionTree.make(item.permissions);
            item.setCheckedKeys = [];
            // item.treeData.forEach((f) => {
            //   _this.circulation(f);
            // });
          });
          _this.sysList = res.items;
        })
        .finally(() => {
          this.open();
        });
    },
    methods: {
      check(data, obj) {
        this.sysList.forEach((sys) => {
          if (sys.code == this.sys.code) {
            sys.setCheckedKeys = this.$refs.ptree.getCheckedKeys(true); //权限保存
          }
        });
      },
      initTree() {
        this.sysList.forEach((sys) => {
          let chks = this.entity.permissions.filter((item) => item.indexOf(sys.code) == 0);
          sys.setCheckedKeys = chks || []; //权限贮存
        });
      },
      //  getCheckedKeys(){
      //       this.sysList.forEach(sys=>{
      //         if(sys.sysCode == this.sys.sysCode){
      //            sys.setCheckedKeys = this.$refs.ptree.getCheckedKeys(true)
      //         }
      //      })
      //      console.log(this.sysList);
      //   },
      setCheckedKeys() {
        this.sysList.forEach((sys) => {
          if (sys.code == this.sys.code) {
            this.$refs.ptree.setCheckedKeys(sys.setCheckedKeys); //权限设置
          }
        });
      },
      resize() {},
      confirm(sys) {
        this.sys = sys;
        this.setCheckedKeys();
      },
      changePid(parent) {
        parent.children.forEach((c) => {
          c.pid = parent.code;
          this.circulation(c);
        });
      },
      circulation(item) {
        if (item.children && item.children.length) {
          this.changePid(item);
        }
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      open() {
        let _this = this;
        if (this.roleId) {
          this.loading = true;
          api.Role.get(this.roleId)
            .then((res) => {
              _this.entity = res;
              _this.initTree();
              if (_this.entity.permissions.length) {
                let sysCode = _this.entity.permissions[0].split("_")[0];
                let sys = _this.sysList.find((s) => s.code == sysCode);
                _this.confirm(
                  sys || {
                    treeData: [],
                    sysCode: undefined,
                  }
                );
              }
            })
            .finally(() => {
              _this.loading = false;
            });
        } else {
          this.entity = {
            permissions: [],
          };
        }
      },
      // treeInit() {
      //   // let i = 0;
      //   // this.sysList.forEach((sys) => {
      //   this.$refs.ptree.setCheckedKeys([]);
      //   // });
      // },
      save: function () {
        let _this = this;
        this.$refs.editor
          .validate()
          .then((valid) => {
            _this.saving = true;
            // let i = 0;
            _this.entity.permissions = [];
            // _this.sysList.forEach((sys) => {
            //   _this.entity.permissions.push(
            //     ..._this.$refs.ptree.getCheckedKeys(true)
            //   );
            // });

            _this.sysList.forEach((sys) => {
              _this.entity.permissions.push(...sys.setCheckedKeys);
            });

            return api.Role.save(_this.entity);
          })
          .then((newEntity) => {
            _this.saving = false;
            _this.$emit("update:visible", false);
            _this.$emit("ok", newEntity);
            _this.$message.success("保存成功！");
          })
          .catch((err) => {
            _this.saving = false;
            if (err) {
              _this.$message.error(err.message || err);
            }
          });
      },
    },
  };
</script>
